// import {get, post} from '../http'
import {handleSend} from '../handleSend'

export const SysManageApi = {
  //
  //   *系统基础管理*
  //
  // 系统参数查询
  querySysParameter (data) {
    // data.pageNum = String(data.pageNum)
    // data.pageSize = String(data.pageSize)
    return handleSend(data, '10', '0001', '0', 'message')
  },
  // 系统参数修改
  updateSysParameter (data) {
    return handleSend(data, '10', '0002', '0')
  },
  //
  // 机构资料管理（11）
  //
  // 新增/修改机构接口
  handleInstitution (data, type = 0) {
    return handleSend(data, '11', '0001', String(type))
  },
  // 查询机构接口
  queryInstitutionList (data, isDesensit = 'true') {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '11', '0002', '0', 'message', isDesensit)
  },
  // 机构撤销接口
  delInstitution (data) {
    return handleSend(data, '11', '0003', '0')
  },
  // 产品列表设置接口（11,0004
  setProduct (data) {
    return handleSend(data, '11', '0004', '0')
  },
  // 设置机构图片接口（11,0005
  setInstImg (data) {
    return handleSend(data, '11', '0005', '0')
  },
  // 查询机构图片接口（11,0006
  queryImg (data) {
    return handleSend(data, '11', '0006', '0')
  },
  //
  // *支付渠道管理*
  //
  // 新增/修改支付渠道基本信息接口（12,0001）
  handlePaymentchannelinformation (data, type = 0) {
    return handleSend(data, '12', '0001', String(type))
  },
  // 查询支付渠道基本信息接口（12,0002）
  queryPaymentchannelinformationList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '12', '0002', '0', 'message')
  },
  // 渠道基本信息删除接口（12,0003）
  delPaymentchannelinformation (data) {
    return handleSend(data, '12', '0003', '0')
  },
  // 新增/修改支付渠道应用配置接口（12,0004
  handlePaymentChannelApplication (data, type = 0) {
    return handleSend(data, '12', '0004', String(type))
  },
  // 查询支付渠道应用配置接口（12,0005）
  queryPaymentChannelApplicationList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '12', '0005', '0', 'message')
  },
  // 渠道应用配置删除接口（12,0006）
  delPaymentChannelApplication (data) {
    return handleSend(data, '12', '0006', '0')
  },
  //
  //  *码表管理（13）*
  //
  // 新增/修改码表接口（13,0001）
  handleCodeTable (data, type = 0) {
    return handleSend(data, '13', '0001', String(type))
  },
  // 查询码表接口（13,0002）
  queryCodeTableList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '13', '0002', '0', 'message')
  },
  // 删除码表接口（13,0003）
  delCodeTable (data) {
    return handleSend(data, '13', '0003', '0')
  },
  //
  // *工作日管理（14）*
  //
  // 新增/修改工作日接口（14,0001）
  handleWorkDay (data, type) {
    return handleSend(data, '14', '0001', String(type))
  },
  // 查询工作日接口（14,0002）
  queryWorkDay (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '14', '0002', '0', 'message')
  },
  // 删除工作日接口（14,0003）
  delWorkDay (data) {
    return handleSend(data, '14', '0003', '0')
  },
  //
  // *跨区应用设置（15）*
  //
  // 跨区设置/修改接口（15,0001）
  handleTransregionalSetting (data, type) {
    return handleSend(data, '15', '0001', String(type))
  },
  // 查询跨区设置接口（15,0002）
  queryTransregionalSettingList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '15', '0002', '0', 'message')
  },
  // 删除跨区设置接口（15,0003）
  delTransregionalSetting (data) {
    return handleSend(data, '15', '0003', '0')
  },
  //
  // *操作员管理(2)*
  //
  // *角色资料管理（20）*
  //
  // 新增/修改角色资料接口（20,0001）
  handleRoleInfo (data, type) {
    return handleSend(data, '20', '0001', String(type))
  },
  // 查询角色资料接口（20,0002）
  queryRoleList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '20', '0002', '0', 'message')
  },
  // 删除角色资料接口（20,0003）
  delRoleInfo (data) {
    return handleSend(data, '20', '0003', '0')
  },
  // 查询角色权限接口（20,0004）
  queryRolePermiss (data) {
    return handleSend(data, '20', '0004', '0', 'message')
  },
  // 角色权限分配接口（20,0005）
  setRolePermiss (data) {
    return handleSend(data, '20', '0005', '0')
  },
  //
  // *操作员管理（21）*
  //
  // 新增/修改操作员接口（21,0001）
  handleUser (data, type = 0) {
    return handleSend(data, '21', '0001', String(type))
  },
  // 查询操作员接口（21,0002）
  queryUserList (data, isDesensit = 'true') {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '21', '0002', '0', 'message', isDesensit)
  },
  // 注销/停用/释放登录状态接口（21,0004）
  setUserStatus (data, type) {
    // console.log('状态操作接口', type, String(type))
    return handleSend(data, '21', '0004', String(type))
  },
  // 重置密码及启用接口（21,0005）
  resetPwd (data) {
    return handleSend(data, '21', '0005', '0')
  },
  // 查询操作员角色接口（21,0006）
  queryUserRole (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '21', '0006', '0', 'message')
  },
  // 操作员角色分配接口（21,0007）
  setUserRole (data) {
    return handleSend(data, '21', '0007', '0')
  },
  // 管理范围设置接口（21,0008）
  setManageArea (data) {
    return handleSend(data, '21', '0008', '0')
  },
  // 管理范围查询接口（21,0009）
  queryManageArea (data) {
    return handleSend(data, '21', '0009', '0')
  },
  // 3.3.2.9.查询操作员商户接口（21,0010）
  userMerchList (data, isDesensit = 'true') {
    return handleSend(data, '21', '0010', '0', 'message', isDesensit)
  },
  // 3.3.2.10.操作员商户配置接口（21,0011）
  setUserMerch (data) {
    return handleSend(data, '21', '0011', '0')
  },
  // 审计日志(22）
  //
  // 查询审计日志接口（22,0001）
  queryAuditLog (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '22', '0001', '0', 'message')
  }
}



// WEBPACK FOOTER //
// ./src/request/SysManage/sys_manage_api.js